import { useState } from "react";

const faqs = [
  {
    q: "What is ACBuySpreadsheet?",
    a: "ACBuySpreadsheet is a structured product sourcing spreadsheet system designed specifically for ecommerce operators and dropshipping entrepreneurs. It centralizes product research data, supplier tracking, pricing comparisons, and workflow management into one organized system — replacing the chaos of scattered notes and manual tracking methods.",
  },
  {
    q: "How does ACBuySpreadsheet improve product sourcing efficiency?",
    a: "By providing a pre-built, organized spreadsheet framework, ACBuySpreadsheet eliminates the need to build tracking systems from scratch. Product data, supplier details, pricing tiers, and shipping information are all captured in a standardized format, enabling faster comparison, better decision-making, and reduced time spent on repetitive manual data entry.",
  },
  {
    q: "Is ACBuySpreadsheet suitable for beginners?",
    a: "Absolutely. The system is designed with a clear, intuitive structure that works for both newcomers to ecommerce and experienced operators scaling their business. The spreadsheet layout is logical and easy to navigate, with dedicated sections for each stage of the product sourcing workflow.",
  },
  {
    q: "Can ACBuySpreadsheet handle multiple suppliers and product categories?",
    a: "Yes — scalability is one of the core advantages. The spreadsheet system is built to accommodate unlimited product entries across multiple suppliers and categories. Whether you are sourcing 50 products or 5,000, the same structured framework keeps everything organized and accessible.",
  },
  {
    q: "How is ACBuySpreadsheet different from using regular Google Sheets?",
    a: "While ACBuySpreadsheet utilizes spreadsheet technology, it is much more than a blank sheet. It comes with pre-configured templates, formulas, and organizational structures specifically optimized for ecommerce product sourcing. It is purpose-built rather than generic, saving hours of setup time and reducing the risk of data inconsistency.",
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="py-16 md:py-24 px-6 md:px-10 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12">
            <span className="text-xs font-medium text-primary-600 uppercase tracking-widest">
              Frequently Asked Questions
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mt-3">
              Everything You Need to Know
            </h2>
          </div>

          <div className="space-y-3">
            {faqs.map((faq, i) => (
              <div
                key={i}
                className="rounded-lg bg-background-100 overflow-hidden"
              >
                <button
                  onClick={() => setOpenIndex(openIndex === i ? null : i)}
                  className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                >
                  <span className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                    {faq.q}
                  </span>
                  <span className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === i ? "rotate-45" : ""}`}>
                    <i className="ri-add-line text-foreground-500"></i>
                  </span>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    openIndex === i ? "max-h-96 pb-4" : "max-h-0"
                  }`}
                >
                  <p className="px-5 text-sm text-foreground-600 leading-relaxed">
                    {faq.a}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}